/**
 * Выбирает пару ключ-значение, соответствующие заданным ключам из объекта
 *
 * Пример использование pick({a: 1, b: 2, c: 3}, ['a', 'b'])
 *
 * @param obj объект со значениями {a: 1, b: 2, c: 3}
 * @param arr массив c ключами ['a', 'c']
 * @returns Pick<Obj, Key>
 */

export const pick = (obj, arr) => arr.reduce((acc, curr) => {
  if (curr in obj) {
    acc[curr] = obj[curr];
  }
  return acc;
}, {});